import {
  VTextField,
  VTextarea,
  VAutocomplete,
  VSelect
} from 'vuetify/components';

import DynamicJsonField from '@/components/form/DynamicJsonField.vue';
import DatePickerInput from '@/components/form/DatePickerInput.vue';
import FileUploader from '@/components/form/FileUploader.vue';
import RelatedSalesApplier from '@/components/form/RelatedSalesApplier.vue';

import type { FormField } from '@/types/form';

const today = () => new Date().toISOString().slice(0, 10);

export const CREATE_FORM: FormField[] = [
  {
    value: 'client',
    label: 'Cliente',
    component: VAutocomplete,
    searchValue: 'name',
    required: true,
    col: 6,
    fetchOptions: 'searchClients',
    itemText: (item: any) =>
      item?.attributes?.commercial_name ||
      item?.attributes?.legal_name ||
      item?.attributes?.name || '',
    itemValue: (item: any) => item,
    transform: (value: any) => ({
      client_id: value?.id ?? value,
    })
  },
  {
    value: 'amount',
    label: 'Monto',
    component: VTextField,
    type: 'number',
    prefix: '$',
    required: true,
    col: 6,
  },
  {
    value: 'paid_at',
    label: 'Fecha de Pago',
    component: DatePickerInput,
    required: true,
    col: 6,
    props: {
      modelValue: today(),
    },
    transform: (value: any) => value || today(),
  },
  { 
    value: 'payment_method', 
    label: 'Método de Pago', 
    component: VSelect, 
    searchValue: 'name', 
    required: false, 
    col: 6, 
    fetchOptions: 'searchPaymentForms', 
    itemText: 'name', 
    itemValue: 'name'
  },
  {
    value: 'note',
    label: 'Notas',
    component: VTextarea,
    required: false,
    col: 12,
  },
  {
    value: 'documents',
    label: 'Documentos',
    isJsonArray: true,
    plainJson: false,
    component: DynamicJsonField,
    col: 12,
    children: [
      {
        value: 'label',
        label: 'Etiqueta',
        component: VTextField,
        col: 6,
        required: false,
      },
      {
        value: 'file',
        label: 'Archivo',
        component: FileUploader,
        module: 'collections',
        col: 6,
        required: false,
      }
    ],
  },
  {
    value: 'related_sales',
    label: 'Ventas relacionadas',
    component: RelatedSalesApplier,
    isCustom: true,
    col: 12,
    props: (_: any, form: any) => ({
      clientId: form?.client?.id ?? form?.client_id ?? null,
    }),
    transform: (value: any[]) => ({
      related_sales: (value || []).map(item => ({
        sale_id: item.sale_id,
        amount: item.amount,
      }))
    })
  }
];

export const EDIT_FORM: FormField[] = CREATE_FORM;

export const HEADERS = [
  { title: 'Folio', value: 'id', format: 'text', sortable: true },
  { title: 'Cliente', value: 'client.name', format: 'text', sortable: false },
  { title: 'Complemento', value: 'documents', format: 'text', sortable: false },
  { title: 'Fecha', value: 'paid_at', format: 'text', sortable: true },
  { title: 'Método de pago', value: 'payment_method.name', format: 'text', sortable: false },
  { title: 'Monto', value: 'amount', format: 'text', sortable: true },
  { title: 'Comprobante', value: 'documents', format: 'text', sortable: false },
];

export const DEFAULT_HEADER_ORDER = ['id', 'client.name', 'paid_at', 'amount'];

export const ROW_ACTIONS = [
  { label: 'Editar', onClick: '__edit', permission:'collections.update' },
  { label: 'Eliminar', onClick: '__delete', permission:'collections.delete' },
];

export const FILTERS = [
  { value: 'id', label: 'Folio', component: VTextField },
  { value: 'client_id', label: 'Cliente', component: VAutocomplete, fetchOptions: 'searchClients', itemText: 'attributes.commercial_name', itemValue: (item: any) => item.id },
  { value: 'paid_at', label: 'Fecha de Pago', component: DatePickerInput },
];

export const DETAIL = {
  expand_table: false,
  eye_detail: false,
  key: 'all',
};
